import React from 'react'
import { useCart } from 'lib/core/hooks'
import { useCartItems } from 'hooks/cart'
import { ListItem } from 'components/Cart/components/ListItem'
import { Container } from './components/Styled'

export const List = () => {
  const { cart } = useCart()
  const items = cart?.data?.items
  const cartItems = useCartItems(items)

  if (!items) {
    return null
  }

  return (
    <Container>
      <h2
        className='cart__heading'
      >
        PRODUCTS
      </h2>
      <ul>
        {cartItems?.map(cartItem => {
          const SubItem = cartItem?.associatedProduct
          const [sampleDuration] = cartItem.product.customAttribute?.promotion_days ?? []
          if (SubItem?.id) {
            return (
              <>
                <ListItem
                  isSampleSupply
                  key={cartItem.id}
                  cartItem={cartItem}
                />
                <ListItem
                  key={SubItem?.id}
                  cartItem={SubItem}
                  sampleDuration={sampleDuration}
                  isChild
                />
              </>
            )
          }

          return (
            <ListItem
              key={cartItem?.id}
              cartItem={cartItem}
            />
          )
        })}
      </ul>
    </Container>
  )
}
